module.exports = __webpack_public_path__ + "assets/img/title.4f0c7352.png";